import React, { createContext } from 'react';
import { useLocalStorage } from '@rehooks/local-storage';

export const defaultCart = [];
const defaultContextValue = [ defaultCart, () => {}, () => {} ];
export const CartContext = createContext( defaultContextValue );

const CartProvider = ( { children } ) => {
    const ctxValue = useLocalStorage( 'oc', defaultCart );

    return (
        <CartContext.Provider value={ ctxValue }>
            { children }
        </CartContext.Provider>
    );
};

export { CartProvider }
